import { Controller } from "@hotwired/stimulus"
import { Sortable } from "sortablejs"

// Field-layout editor for the BRZ integration configuration.
//
// The rows submit as `integration[settings][fields][][…]`, so the column order
// IS the DOM order and dragging a row is all it takes to reorder the export —
// no position bookkeeping. That only holds while every row submits the same
// keys exactly once, which is why the on/off switches drive a hidden input
// instead of being checkboxes: an unchecked checkbox submits nothing and would
// silently merge two rows into one.
export default class extends Controller {
  static targets = ["list", "row", "template", "emptyState"]

  connect() {
    if (this.hasListTarget) {
      this.sortable = new Sortable(this.listTarget, {
        draggable: '[data-brz-layout-target="row"]',
        handle: "[data-brz-layout-handle]",
        animation: 150,
        ghostClass: "bg-gray-100",
      })
    }
    this.refreshEmptyState()
  }

  disconnect() {
    this.sortable?.destroy()
    this.sortable = null
  }

  addRow(event) {
    event.preventDefault()
    if (!this.hasTemplateTarget) return

    const row = this.templateTarget.content.firstElementChild.cloneNode(true)
    this.listTarget.appendChild(row)
    this.refreshEmptyState()
  }

  removeRow(event) {
    event.preventDefault()
    event.currentTarget.closest('[data-brz-layout-target="row"]')?.remove()
    this.refreshEmptyState()
  }

  // Mirrors a visible checkbox into the hidden input that actually submits.
  toggleFlag(event) {
    const checkbox = event.currentTarget
    const hidden = checkbox.parentElement?.querySelector("input[type=hidden]")
    if (hidden) hidden.value = checkbox.checked ? "1" : "0"
  }

  refreshEmptyState() {
    if (!this.hasEmptyStateTarget) return

    this.emptyStateTarget.classList.toggle("hidden", this.rowTargets.length > 0)
  }
}
